import { render, staticRenderFns } from "./DialogIndexMap.vue?vue&type=template&id=679106f9&scoped=true"
import script from "./DialogIndexMap.vue?vue&type=script&lang=js"
export * from "./DialogIndexMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679106f9",
  null
  
)

export default component.exports